/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { PaymentTypeModelIEnumerableResponseWrapper } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class PaymentTypes<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Payment
   * @name GetPaymentTypes
   * @request GET:/PaymentTypes
   */
  getPaymentTypes = (params: RequestParams = {}) =>
    this.request<PaymentTypeModelIEnumerableResponseWrapper, any>({
      path: `/PaymentTypes`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
